module.exports = __webpack_public_path__ + "static/img/vip.d558222f.png";